<!-- General Confirmation Window -->
<app-confirmation-window #confirmationWindow></app-confirmation-window>
<!-- General Exit Confirmation Window -->
<app-leave-page-confirmation #exitConfirmOverlay></app-leave-page-confirmation>
<!-- Delete Overlay -->
<app-confirmation-window
    #deleteConfirmationOverlay
    [mainLabel]="
        'forms.channels.custom-group.delete-confirmation-prompt' | translate
    "
    [confirmLabel]="
        'forms.channel.custom-group.delete-confirmation-button' | translate
    "
    [cancelLabel]="
        'forms.channel.custom-group.delete-cancel-button' | translate
    "
></app-confirmation-window>

<div
    style="height: 100%"
    class="channel-view"
    *ngIf="hasFinishedLoading; else loadingSpinner"
    #mainContent
>
    <!-- View Selection -->
    <div
        [ngClass]="[
            'views-container',
            responsive.deviceAndOrientation,
            responsive.screenSize,
        ]"
        *ngIf="
            viewMode !== VIEWMODE_ADVANCED_CHANNEL &&
            viewMode !== VIEWMODE_NEW_CUSTOM_GROUP
        "
    >
        <app-scroll-navigator
            class="scroll-navigator-container"
            [items]="filteredCustomGroups"
            [selectedId]="selectedGroupId"
            [routerPath]="['/ops', 'groups', '', 'channels']"
            [showDefaultItem]="true"
            [defaultItem]="{
                displayName: 'forms.channel.tab-titles.all-channels',
                routerLink: '/ops/groups',
            }"
        />

        <a
            class="create-group-button"
            (click)="onCreateGroup()"
        >
            <mat-icon svgIcon="blue-add" />
            <p data-cy="add-new-channel-group-button" style="text-wrap: nowrap">
                {{ "channel-page.label.add-group" | translate }}
            </p>
        </a>
    </div>

    <div
        *ngIf="
            (viewMode == VIEWMODE_GROUPS && responsive.isSmall()) ||
            (viewMode == VIEWMODE_GROUPS && responsive.isXSmall())
        "
        class="add-group-wrap container-width"
    >
        <button class="border add-group-btn" (click)="onCreateGroup()">
            <mat-icon svgIcon="blue-add" />
            <span>{{ "channel-page.button.add-group" | translate }}</span>
        </button>
    </div>

    <div>
        <app-ops-groups
            *ngIf="viewMode == VIEWMODE_GROUPS"
            [groups]="groups"
            [channels]="channels"
            [filteredCustomGroups]="
                responsive.isXSmall() || responsive.isSmall()
                    ? filteredCustomGroups
                    : []
            "
            [customChannels]="
                responsive.isXSmall() || responsive.isSmall()
                    ? customGroupChannels
                    : []
            "
        ></app-ops-groups>

        <app-ops-channel-list
            #channelSettingsListForm
            *ngIf="viewMode == VIEWMODE_CHANNELS"
            (onEditGroup)="editCustomGroup($event)"
            (onDeleteGroup)="handleDeleteGroup()"
            [customGroup]="customGroup"
            [selectedChannel]="selectedChannel"
            [channels]="displayChannels"
            [title]="selectedGroup?.displayName"
            [description]="selectedGroup?.description"
            [groupId]="selectedGroup?.id"
            [publicAccess]="selectedGroup?.publicAccess"
            (onChannelSelected)="onChannelSelected($event)"
            (onNavigateBack)="onChannelListBack()"
            (onSubmit)="onChannelUpdateClicked($event)"
            (onAdvancedSettings)="onAdvancedChannelDetails($event)"
            (onDeleteAlarm)="onAlarmDisableClicked($event)"
        ></app-ops-channel-list>
    </div>

    <!-- Channel Details Cntainer -->
    <div
        class="channel-details-container"
        *ngIf="focusedChannel && !advancedDetails"
    >
        <app-channel-settings-form
            #channelSettingsForm
            [channel]="focusedChannel"
            [value]="getFocusedChannelValue()"
            (onSubmit)="onChannelUpdateClicked($event)"
            (onUpdateChannelList)="handleUpdateChannelList($event)"
            (onAdvancedSettings)="onAdvancedChannelDetails($event)"
            (onDeleteAlarm)="onAlarmDisableClicked($event)"
            (onCloseClicked)="onCloseChannelDetails()"
        >
        </app-channel-settings-form>
    </div>

    <!-- Advanced channel details container -->
    <div
        *ngIf="viewMode == VIEWMODE_ADVANCED_CHANNEL"
        style="display: flex; justify-content: center"
    >
        <div class="container-width">
            <div class="channel-advanced-container">
                <app-channel-advanced-settings-form
                    #advancedChannelSettingsForm
                    [channel]="focusedChannel"
                    (onExit)="onAdvancedDetailsClosed()"
                    (onSave)="onAdvancedChannelDetailsSubmit($event)"
                    (onCreateGraph)="onCreateGraph($event)"
                    [groupName]="selectedGroup?.displayName"
                >
                </app-channel-advanced-settings-form>
            </div>
            <!-- Padding for the bottom of the page -->
            <div style="height: 150px"></div>
        </div>
    </div>
    <div *ngIf="viewMode == VIEWMODE_NEW_CUSTOM_GROUP">
        <app-ops-new-custom-group
            #newCustomGroup
            [editData]="customGroupData"
            [projectCustomGroups]="customGroups"
            [customGroupNumber]="customGroups.length + 1"
            (onGoBack)="onBackCustomGroup($event)"
            (onSubmitCustomGroup)="onSubmitCustomGroup($event)"
            [channels]="channels"
        ></app-ops-new-custom-group>
    </div>
</div>

<ng-template #loadingSpinner>
    <div class="loading-spinner-container">
        {{ "general.notification.retreiving-data" | translate }}
        <app-loading-spinner
            style="height: 200px; width: 200px"
        ></app-loading-spinner>
    </div>
</ng-template>
